// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"b08690c2","825":"0cea4abc"}[chunkId] + ".chunk.css";
};